import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/how-earnings-work/page.tsx")